export const deliveryDownloadConfig = {
  sectionLabel: 'Manifest Downloads',
  leftButtonLabel: 'Preview version (PDF)',
  leftDownloadUrl: '',
  rightButtonLabel: 'Final version (PDF)',
  rightDownloadUrl: '',
  leftIcon: 'IconDownload',
  rightIcon: 'IconDownload',
  rightSectionIcon: false,
};
